import { render, staticRenderFns } from "./topDestinations.vue?vue&type=template&id=31738dba&scoped=true&"
import script from "./topDestinations.vue?vue&type=script&lang=js&"
export * from "./topDestinations.vue?vue&type=script&lang=js&"
import style0 from "./topDestinations.vue?vue&type=style&index=0&id=31738dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31738dba",
  null
  
)

export default component.exports